// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "基础英语（一）",
      "tec": "刘德娟",
      "week": "6-17周",
      "add": "教学楼A座420机械"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "李昕姝",
      "week": "6-17周",
      "add": "教学楼C座306教务"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼C座115教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "韩峰",
      "week": "6-10周",
      "add": "教学楼C座110教务"
    },
    0
  ],
  "2": [
    {
      "sub": "工程制图与3D建模",
      "tec": "朱爽",
      "week": "6-17周",
      "add": "教学楼A座418机械"
    },
    {
      "sub": "互换性与技术测量",
      "tec": "李玉秀",
      "week": "6-13周",
      "add": "教学楼A座417机械"
    },
    0,
    {
      "sub": "工程力学",
      "tec": "刘小琨",
      "week": "6-17周",
      "add": "教学楼A座417机械"
    },
    {
      "sub": "军事理论",
      "tec": "于天野",
      "week": "6-14周",
      "add": "教学楼C座307教务"
    }
  ],
  "3": [
    0,
    {
      "sub": "基础英语（一）",
      "tec": "刘德娟",
      "week": "7,9,11,13,15,17周",
      "add": "教学楼A座420机械"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工程制图与3D建模",
      "tec": "朱爽",
      "week": "6-17周",
      "add": "教学楼A座418机械"
    },
    {
      "sub": "互换性与技术测量",
      "tec": "李玉秀",
      "week": "6-13周",
      "add": "教学楼A座417机械"
    },
    0,
    {
      "sub": "工程力学",
      "tec": "刘小琨",
      "week": "6-17周",
      "add": "教学楼A座417机械"
    },
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "6-9周",
      "add": "教学楼C座306教务"
    }
  ],
  "5": [
    {
      "sub": "高等数学基础（一）",
      "tec": "李昕姝",
      "week": "6-17单周",
      "add": "教学楼C座306教务"
    },
    0,
    {
      "sub": "马克思主义基本原理",
      "tec": "刘君",
      "week": "6-17周",
      "add": "教学楼C座115教务"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
